import Action from '../action';

export const APP_INITIALIZED = '@app/INITIALIZED';
export const APP_INITIALIZE = '@app/INITIALIZE';
export const LOG_ERROR = '@app/LOG_APP_ERROR';
export const LOG_ERROR_FAILED = '@app/LOG_ERROR_FAILED';
export const LOG_ERROR_SUCCESS = '@app/LOG_ERROR_SUCCESS';
export const APP_LOCALIZED = '@app/LOCALIZED';
export const APP_GOOGLEANATYTICS_SET = '@app/GOOGLEANATYTICS_SET';
export const ANGULAR_BOOTSTRAPPING_STARTED = '@app/ANGULAR_BOOTSTRAPPING_STARTED';
export const SET_APP_BRANDING = '@app/SET_APP_BRANDING';
export const REDIRECT_USER = '@app/REDIRECT_USER';

export const initialized = () => Action(APP_INITIALIZED);
export const localized = () => Action(APP_LOCALIZED);
export const initialize = () => Action(APP_INITIALIZE);
export const startAngularBootstrap = () => Action(ANGULAR_BOOTSTRAPPING_STARTED);
export const appAnalyticsSet = () => Action(APP_GOOGLEANATYTICS_SET);
export const redirectUser = state => Action(REDIRECT_USER, {state});
export const logAppError = (cause, message, url, redirectUrl, stackTrace = []) =>
  Action(LOG_ERROR, {message, cause, url, stackTrace, redirectUrl}, true);
export const logAppErrorSuccess = () => Action(LOG_ERROR_SUCCESS);
export const logAppErrorfailed = () => Action(LOG_ERROR_FAILED);
export const appBranding = (logoUrl, cornerIcon) => Action(SET_APP_BRANDING, {logoUrl, cornerIcon});
